export enum DateFormatEnum {
    DDMMYY = 'DD/MM/YYYY',
    MMDDYY = 'MM/DD/YYYY',
}